<div class="pr-inner-container" id="innerContainer">
    <!-- <div class="py-3 text-base"> -->
    @if (actionData()?.actionTypeId == ActionType.PurchaseRequisition) {
      @if(actionData()?.actionSubTypeId==ActionPRSubType.PRRequest){
        <div class="pb-[8px] text-base" [innerHTML]="prSubTitle()"></div>
      }
      @else if(actionData()?.actionSubTypeId== ActionPRSubType.SubHirePRRequest){
        <div class="pb-[8px] text-base" [innerHTML]="prSubTitle()"></div>
      }
    }
    @if (actionData()?.actionTypeId == ActionType.PurchaseOrder) {
       @if(actionData()?.actionSubTypeId==ActionPOSubType.PORequest){
        <div class="pb-[8px] text-base" [innerHTML]="poSubTitle()"></div>
      }
    }
    <!-- </div> -->
    <div class="body">
      <div class="body-container">
        <div class="supplier">
          <table class="table-fixed border-collapse border border-slate-400 w-full">
              <tbody>
                <tr>
                  <td>ABN</td>
                  <td>{{supplier()?.abn}}</td>
                </tr>
                <tr>
                  <td>Supplier Name</td>
                  <td>{{supplier()?.name}}</td>
                </tr>
              </tbody>
          </table>
        </div>        
        
        @if (actionData()?.actionTypeId == ActionType.PurchaseRequisition) {
        <div class="additional-details">
          <ejs-accordion>
            <e-accordionitems>
              <e-accordionitem [expanded]='false'>
                <ng-template #header>
                  <div class="additional-details-header">
                    <!-- <div class="icon">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.068.157 2.148.279 3.238.364.466.037.893.281 1.153.671L12 21l2.652-3.978c.26-.39.687-.634 1.153-.67 1.09-.086 2.17-.208 3.238-.365 1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z" />
                      </svg>
                    </div> -->
                    <span class="text">Additional Details</span>
                  </div>
                </ng-template>
                <ng-template #content>
                  <div class="additional-details-container">                      
                    <table class="table-fixed border-collapse border border-slate-400 w-full">
                      <tbody>
                        <tr>
                          <td>ETA</td>
                          <td>{{formatDate(actionData()?.additional?.eta)}}</td>
                        </tr><tr>
                          <td>Order Expiry Date</td>
                          <td>{{formatDate(actionData()?.additional?.orderExpiryDate)}}</td>
                        </tr>
                        <tr>
                          <td>Delivery Address</td>
                          <td>{{actionData()?.additional?.deliveryAddress}}</td>
                        </tr>
                      </tbody>
                  </table>
                  </div>
                </ng-template>
              </e-accordionitem>
            </e-accordionitems>
          </ejs-accordion>
        </div>
        }

        @if(singleSourcePurchaseDetails()) {
        <div class="ssa">
          <ejs-accordion>
            <e-accordionitems>
              <e-accordionitem [expanded]='true'>
                <ng-template #header>
                  <div class="additional-details-header">
                    <span class="text">Justification Attachment(s)</span>
                  </div>
                </ng-template>
                <ng-template #content>
                  <div class="ssa-container">
                    @for (file of singleSourcePurchaseDetails().files; track $index) {
                      <div class="quote-item py-[4px]">
                          <div class="flex items-center">
                            <div class="grow">
                              @if(file.fileName){
                                <div class="flex">
                                  <i class="file-icon text-[18px] mt-[0px] mb-[0px] ml-[10px] mr-[10px] content-center">📄</i>
                                  
                                  <span class="quote-name font-medium overflow-hidden inline-block self-center">
                                    <a href="javascript:void(0)" (click)="viewQuoteFile(file)" class="view-link">{{file.fileName}}</a>
                                  </span>
                                </div>
                              }
                            </div>
                          </div>
                      </div>
                    }
                  </div>
                </ng-template>
              </e-accordionitem>
            </e-accordionitems>
          </ejs-accordion>
        </div>
        }

        <div class="line-items-container">
          <h3>Selected Items</h3>

          <ejs-grid #grid height='100%' [dataSource]='lineItems()' [loadingIndicator]="'loadingIndicator'" 
              gridLines='Both' width='auto' height="auto" [selectionSettings]="selectionSettings"
              [allowSelection]="true" [allowSelection]="true" [detailTemplate]="detailTemplate"
              (rowDataBound)="onRowDataBound($event)" (dataBound)="onGridDataBound()">
            <ng-template #detailTemplate let-data>
              <!-- This is the expanded row content -->
              <div class="p-2 bg-gray-100 border rounded detail-container">
                <p><strong>Name:</strong> {{ data.name }}</p>
                <p><strong>Description:</strong> {{ data.description }}</p>
                <p><strong>Quantity:</strong> {{ data.quantity  }}</p>
                <p><strong>Unit Price:</strong> {{ data.unitPrice | currency }}</p>
                <p><strong>Total Amount:</strong> {{ data.totalAmount | currency }}</p>
              </div>
            </ng-template>
            <e-columns>
                <e-column field="id" headerText="ID" [visible]="false" isPrimaryKey="true" [showInColumnChooser]="false"></e-column>
                <e-column type='checkbox' allowFiltering='false' allowSorting='false' [width]='40' textAlign='Left'></e-column>

                <e-column field='name' headerText="Item" visible='true' [allowSorting]="'false'"
                    type='string' textAlign='Left' [allowFiltering]="'false'">
                    <ng-template #template let-data>
                      <div class="name-container">
                        <div class="icon-sec">
                          @if(data.prevActionType === actionType.Approved){
                            <span class="e-icons e-circle approved"></span>
                          }
                          @else if(data.prevActionType === actionType.Rejected){
                            <span class="e-icons e-circle rejected"></span>
                          }
                          @else if(data.prevActionType === actionType.Requested){
                            <span class="e-icons e-circle requested"></span>
                          }
                        </div>
                        <div class="name">
                            <span>{{data.name}}
                              @if(data.description) { @if(data.name) { - } {{data.description}}}
                              @if(data.extendedDescription) {{{data.extendedDescription}}}
                            </span>
                            <!-- <span *ngIf="data.description"> - {{ data.description }}</span> -->
                            <!-- <span>{{data.description}}</span> -->
                        </div>
                        @if(isMobile()){
                        <div class="details-sec">
                          <a class="e-icons e-swimlane-row-collapse" href="javascript:void(0)" 
                              (click)="onDetailsClick($event, data, grid)">
                          </a>
                        </div>
                        }
                      </div>
                  </ng-template>
                </e-column>

                @if(!isMobile()){
                <e-column field='unitPrice' headerText="Unit Price" visible='true' [allowSorting]="'false'"
                    type='string' textAlign='Right' [width]="'100'" [allowFiltering]="'false'">
                    <ng-template #template let-data>
                      <div class="unit-price">
                          {{data.unitPrice | currency:'USD':'symbol':'1.2-2'}}
                      </div>
                  </ng-template>
                </e-column>

                <e-column field='quantity' headerText="Qty" visible='true' [allowSorting]="'false'"
                    type='string' textAlign='Center' [width]="'50'" [allowFiltering]="'false'">
                    <ng-template #template let-data>
                      <div class="quantity">
                          {{data.quantity}}
                      </div>
                  </ng-template>
                </e-column>
                }
                <e-column field='totalAmount' headerText="Total" visible='true' [allowSorting]="'false'"
                    type='string' textAlign='Right' [width]="'120'" [allowFiltering]="'false'">
                    <ng-template #template let-data>
                      <div class="unit-amount">
                          {{data.totalAmount | currency:'USD':'symbol':'1.2-2'}}
                      </div>
                  </ng-template>
                </e-column>

            </e-columns>
            
            <e-aggregates>
              <e-aggregate>
                <e-columns>
                  <e-column field="name" type="Custom">
                    <ng-template #footerTemplate>
                      Total: 
                    </ng-template>
                  </e-column>
                  <e-column field="totalAmount" type="Custom">
                    <ng-template #footerTemplate>                      
                      <div style="text-align:right; padding-right: 4px;">
                        {{ totalAmount() | currency:'USD':'symbol':'1.2-2' }}
                      </div>
                    </ng-template>
                  </e-column>
                </e-columns>
              </e-aggregate>
            </e-aggregates>
          </ejs-grid>

        </div>
      </div>
    </div>

    <div class="actions">
      <button class="btn btn-reject" (click)="onRejectClick($event)" [disabled]="actionButton()?.disabledReject || inProgress()">
        <span class="e-icons e-circle-close-2"></span>
        <span class="text">Reject</span>
      </button>
      <button class="btn btn-request" (click)="onRequestInfoClick($event)" [disabled]="actionButton()?.disabledRequestInfo || inProgress()">
        <span class="e-icons e-circle-info"></span>
        <span class="text">Request Info</span>
      </button>
      <button class="btn btn-approve" (click)="onApproveClick($event)" [disabled]="actionButton()?.disabledApproved || inProgress()">
        <span class="e-icons e-circle-check"></span>
        <span class="text">Approve</span>
      </button>
    </div>
    
    <div class="quotes" *ngIf="quotes()?.length>0">
      <h3>Quotes</h3>
  
      @for (quote of quotes(); track $index) {
        <div *ngIf="quote && quote.quoteFiles && quote.quoteFiles.length>0" class="quote-item" [ngClass]="{ 'selected': quote.isWinner }">
             <div class="flex items-center">
                @if(quote.isWinner){
                  <span class="e-icons e-circle-check cirle" [ngClass]="{ 'winner-icon': quote.isWinner }"></span>
                }
                @else{
                  <span class="e-icons e-circle cirle"></span>
                }
                <div class="grow">
                  @for (file of quote.quoteFiles; track $index) {
                    @if(file.fileName){
                      <div class="flex">
                        <i class="file-icon text-[18px] mt-[0px] mb-[0px] ml-[10px] mr-[10px] content-center">📄</i>
                        
                        <span class="quote-name font-medium overflow-hidden inline-block self-center">
                          <a href="javascript:void(0)" (click)="viewQuoteFile(file)" class="view-link">{{file.fileName}}</a>
                        </span>
                      </div>
                    }
                  }
                </div>

                <div class="winner-badge">
                  @if(quote.isWinner){
                    Winner
                  }
                </div>
             </div>

              <div class="">
                @if(quote.reason){
                  {{quote.reason}}
                }
              </div>
        </div>
      }
    </div>
    
    <div class="comments">
      <ejs-accordion>
        <e-accordionitems>
          <e-accordionitem [expanded]='true'>
            <ng-template #header>
              <div class="comments-header">
                <div class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.068.157 2.148.279 3.238.364.466.037.893.281 1.153.671L12 21l2.652-3.978c.26-.39.687-.634 1.153-.67 1.09-.086 2.17-.208 3.238-.365 1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z" />
                  </svg>
                </div>
                <span class="text">Comments</span>
              </div>
            </ng-template>
            <ng-template #content>
    
              <div class="send-comment rounded-[24px] p-[6px] border border-solid border-[#e0e0e0] mb-[10px]">
                <div>
                  <ejs-textarea #comment cssClass="e-outline h-20" class="comment-area" maxLength="1000" placeholder='Comment'
                      id="comment" floatLabelType="Never" height="50" [(ngModel)]="chatMsg.message" (input)="onCommentChange($event)">
                  </ejs-textarea>
                </div>
                <div class="flex items-center justify-between">
                  <div>
                    <ejs-uploader #chatFile  [autoUpload]='false' [maxFileSize]="5242880" [multiple]="false" class="file-uploader"
                      [buttons]="uploaderButtons"
                      [allowedExtensions]="'.png,.jpg,.jpeg,.gif,.bmp,.pdf,.doc,.docx,.xls,.xlsx'" style="width: 100%;">
                    </ejs-uploader>
                  </div>
                  <div>
                    <button class="btn-send flex justify-center items-center rounded-[9999px] border-[1px] text-white w-[30px] h-[30px]"
                      (click)="onCommentSendClick($event)" [disabled]="disabledSendButton()">
                      <!-- <span class="text">Send</span> -->
                      <!-- <span class="e-icons e-arrow-down font-bold"></span> -->
                      <svg class="size-[16px]" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                        <line x1="22" y1="2" x2="11" y2="13" />
                        <polygon points="22 2 15 22 11 13 2 9 22 2" />
                      </svg>
                    </button>
                  </div>
                </div>
                  
              </div>

              <div class="chat-container">
                @for (chat of chats(); track $index) {
                  @if(chat.requesterUserName && chat.message){
                    <div class="chat-message rounded-[8px] px-[4px] py-[3px] max-w-[400px] min-w-[250px]"
                      [ngClass]="chat.requesterUserEmail.toLowerCase()==getLoggedInUserEmail().toLowerCase() ? 'self-end' : 'self-start'">
                      <div class="chat-header flex justify-between text-[14px] mb-[6px]">
                          <strong class="min-w-[200px]">{{chat.requesterUserName}}</strong>
                          <span class="chat-time">{{formatDateTime(chat.date)}}</span>
                      </div>
                      <div class="chat-text">
                          {{chat.message}}
                      </div>
                      <div class="chat-file" *ngIf="chat.fileName">
                        <a href="javascript:void(0)" (click)="viewChatFile(chat)" class="view-link">{{chat.fileName}}</a>
                      </div>
                    </div>
                  }
                  @else if(chat.approverUserName){
                    <div class="chat-message alt rounded-[8px] border border-solid px-[4px] py-[3px] max-w-[400px] min-w-[250px]"
                      [ngClass]="chat.approverUserEmail.toLowerCase()==getLoggedInUserEmail().toLowerCase() ? 'self-end' : 'self-start'">
                      <div class="chat-header flex justify-between text-[14px] mb-[6px]">
                        <strong class="min-w-[200px]">{{chat.approverUserName}}</strong>
                        <span class="chat-time">{{formatDateTime(chat.date)}}</span>
                      </div>
                      <div class="chat-text">
                        {{chat.message}}
                      </div>
                      <div class="chat-file" *ngIf="chat.fileName">
                        <a href="javascript:void(0)" (click)="viewChatFile(chat)" class="view-link">{{chat.fileName}}</a>
                      </div>
                  </div>
                  }
                }
              </div>
            </ng-template>
          </e-accordionitem>
        </e-accordionitems>
      </ejs-accordion>
    </div>

    <div class="audit">
      <ejs-accordion>
        <e-accordionitems>
          <e-accordionitem [expanded]='false'>
            <ng-template #header>
              <div class="audit-header">
                <div class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clipboard-list-icon lucide-clipboard-list"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><path d="M12 11h4"/><path d="M12 16h4"/><path d="M8 11h.01"/><path d="M8 16h.01"/></svg>
                </div>
                <span class="text">Audit Logs</span>
              </div>
            </ng-template>
            <ng-template #content>
              <itm-audit-detail class="w-full" [actionData]="actionData()"></itm-audit-detail>
            </ng-template>
          </e-accordionitem>
        </e-accordionitems>
      </ejs-accordion>
    </div>

</div>

<ejs-dialog #dialogObj cssClass="reject-dialog"
  [visible]="false"
  [width]="'500px'"
  [isModal]="true"
  [header]="'Reject Confirmation'"
  [showCloseIcon]="true"
  [footerTemplate]="footerTemplate"
  (close)="onDialogClose()">
  <ng-template #content>
    <div class="p-2">
       <ejs-textarea #comment cssClass="e-outline h-20 rounded-[24px] p-[6px] border border-solid border-[#e0e0e0] mb-[10px]" 
            class="reason-area" maxLength="1000" placeholder='Reject Reason'
            id="rejectReason" floatLabelType="Never" height="70" [(ngModel)]="rejectReason" 
            (input)="onRejectReasonChange($event)">
        </ejs-textarea>
    </div>
  </ng-template>

  <ng-template #footerTemplate>
    <button ejs-button class="btn" (click)="closeDialog()">
      <span class="text">Cancel</span>
    </button>
    <button class="btn btn-confirm" [disabled]="disabledRejectConfirmButton()" (click)="confirmReject($event)">
      <span class="text">Confirm</span>
    </button>
  </ng-template>
</ejs-dialog>